import React from 'react';

const ErrorMessage = (props) => {

  return (
    <div className="errorWrapper">
      <p>Sorry, we can’t find any respresentatives in your district.</p>
      <p>Try a nearby zip code?</p>
    </div>
  );
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/Error.js